// extracted by mini-css-extract-plugin
export default {"header":"HeaderSimple_header__vk6nK","link":"HeaderSimple_link__idIUe","inputSearch":"HeaderSimple_inputSearch__MwafV"};